import { FloatButton } from 'antd';
import dynamic from 'next/dynamic';
import { useSelector } from 'react-redux';
import { ReactNode, useEffect } from 'react';
import { useRouter } from 'next/router';
import { authService } from '@services/index';
import classNames from 'classnames';
import style from './primary-layout.module.scss';

const Header = dynamic(() => import('@components/common/header/header'));
const Footer = dynamic(() => import('@components/common/footer'));

interface DefaultProps {
  children: ReactNode;
  authenticate?: boolean;
  noredirect?: boolean;
}

function PrimaryLayout({
  children,
  authenticate = false,
  noredirect = false
}: DefaultProps) {
  const loggedIn = useSelector((state: any) => state.auth.loggedIn);
  const router = useRouter();

  // Handle auth redirects client-side
  useEffect(() => {
    const token = authService.getToken();

    if (authenticate && !token && !loggedIn && !noredirect) {
      router.push(`/auth/login?redirect=${encodeURIComponent(router.asPath)}`);
    }
  }, [authenticate, loggedIn, noredirect, router]);

  const isHomePage = router.pathname === '/home';

  return (
    <div id="primaryLayout" className="main-layout">
      <Header />
      <div className="main-content">
        {children}
      </div>
      <Footer compact fixed={isHomePage} />
      {!router.asPath.includes('/messages')
       && !router.asPath.includes('/live')
       && !router.asPath.includes('/streaming')
       && <FloatButton.BackTop className={classNames(style.backTop, { [style.backTopHome]: isHomePage })} />}
    </div>
  );
}

export default PrimaryLayout;
